export default "__VITE_ASSET__BQEWtWcJ__"